export default function CardBtns() {
    return (
        <div className="button-container">
            <button className="btns" id="email">Email</button>
            <button className="btns" id="indeed">Indeed</button>
        </div>
    )
}